import { FormatColorFill } from '@mui/icons-material';
import BorderAll from '@mui/icons-material/BorderAll';
import BorderBottom from '@mui/icons-material/BorderBottom';
import BorderClearOutlined from '@mui/icons-material/BorderClearOutlined';
import BorderLeft from '@mui/icons-material/BorderLeft';
import BorderRight from '@mui/icons-material/BorderRight';
import BorderTop from '@mui/icons-material/BorderTop';
import LineStyleOutlined from '@mui/icons-material/LineStyleOutlined';
import PercentOutlined from '@mui/icons-material/PercentOutlined';
import TagIcon from '@mui/icons-material/Tag';
import TitleIcon from '@mui/icons-material/Title';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import { CellFormat } from '@services/api/deckManagement/graphql/schema/API';
import { MenuOption } from 'types/Common.types';
import { BorderType, CellColor, LineThickness } from 'types/DecklineFormatting.types';

/** Border formatting options for row styling */
export const borderOptions: MenuOption<BorderType>[] = [
  { value: BorderType.BOTTOM, icon: <BorderBottom />, label: 'Bottom Border' },
  { value: BorderType.TOP, icon: <BorderTop />, label: 'Top Border' },
  { value: BorderType.LEFT, icon: <BorderLeft />, label: 'Left Border' },
  { value: BorderType.RIGHT, icon: <BorderRight />, label: 'Right Border' },
  { value: BorderType.ALL, icon: <BorderAll />, label: 'All Borders' },
  { value: BorderType.NONE, icon: <BorderClearOutlined />, label: 'No Border' },
];

/** Number formatting options for cell values */
export const numberFormatOptions: MenuOption<CellFormat>[] = [
  { value: CellFormat.NONE, icon: <TitleIcon />, label: 'None' },
  { value: CellFormat.NUMBER, icon: <TagIcon />, label: 'Number' },
  { value: CellFormat.PERCENT, icon: <PercentOutlined />, label: 'Percent' },
  { value: CellFormat.PERCENT_1, icon: <PercentOutlined />, label: 'Percent 1 Decimal' },
  { value: CellFormat.PERCENT_2, icon: <PercentOutlined />, label: 'Percent 2 Decimal' },
  { value: CellFormat.BPS, icon: <TitleIcon />, label: 'BPS' },
];

/** Cell background color options */
export const cellColorOptions: MenuOption<CellColor>[] = [
  {
    value: CellColor.WHITE,
    icon: (
      <Box>
        <Badge
          className='formatter-color-dot'
          variant='dot'
          color='white'
          overlap='circular'
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <FormatColorFill />
        </Badge>
      </Box>
    ),
    label: 'White',
  },
  {
    value: CellColor.GREY,
    icon: (
      <Box>
        <Badge
          className='formatter-color-dot'
          variant='dot'
          color='customGrey'
          overlap='circular'
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <FormatColorFill />
        </Badge>
      </Box>
    ),
    label: 'Grey',
  },
];

/** Line thickness options for borders */
export const lineThicknessOptions: MenuOption<LineThickness>[] = [
  { value: LineThickness.THIN, icon: <LineStyleOutlined />, label: 'Thin Line' },
  { value: LineThickness.THICK, icon: <LineStyleOutlined />, label: 'Thick Line' },
];
